import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import UserAvatar from '../Users/UserAvatar';
import CardRow from '../Kanban/CardRow';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import mainStore from '../../../MainStore'
import AuthStore from '../../Auth/AuthStore'
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default class ClientCard extends React.Component {
    constructor(props) {
        super(props);

        var timer = localStorage.getItem("timer" + props.work.id);

        if (timer) {
            timer = JSON.parse(timer);
            this.continueTime();
        }

        this.state = {
            isTimeDialogOpen: false,
            isOver: false,
            time: '',
            comment: '',
            needLogin: false,
            snackbarOpen: false,
            newNotify: '',
            isCommentDialogOpen: false,
            flagDialogTitle: '',
            flagComment: '',

        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleTimeClose = this.handleTimeClose.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleTimeSave = this.handleTimeSave.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
        this.handleTopClick = this.handleTopClick.bind(this);
        this.handleDownClick = this.handleDownClick.bind(this);
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleClose() {
        this.setState({ isWorkDialogOpen: false });
    }

    handleTimeClose() {
        this.setState({ isTimeDialogOpen: false });
    }

    handleTimeSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/AddTime', {
            method: 'POST',
            body: JSON.stringify({ Time: this.state.time, WorkId: this.props.work.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                mainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onTimeChange) {
                        scope.props.onTimeChange(result.time, scope.props.work.id)
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ isTimeDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDragOver(e) {
        if (e.preventDefault) {
            e.preventDefault(); // Necessary. Allows us to drop.
        }
        if (!this.state.isOver) {
            this.setState({ isOver: true });
        }

        e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.
        return false;
    }

    handleCardClick(e) {
        if (e.ctrlKey && this.props.onCtrlCardClick) {
            this.props.onCtrlCardClick(this.props.work.id);
        }
    }

    handleSnackbarClose() {
        this.setState({ snackbarOpen: false, newNotify: '' });
    }

    formatTime(time, useSecond = true) {
        var str = "";
        var hours = Math.floor(time / 3600);
        if (hours > 0 && hours < 10) {
            str += '0' + hours + "ч ";
        }
        else if (hours >= 10) {
            str += hours + "ч ";
        }

        var minutes = Math.floor((time/60)%60);

        if (minutes >= 10) {
            str += minutes + "м ";
        }
        else {
            str += '0' + minutes + "м ";
        }

        if (useSecond) {
            var seconds = time % 60;

            if (seconds >= 10) {
                str += seconds + "с";
            }
            else {
                str += '0' + seconds + "с";
            }
        }

        return str;
    }

    continueTime() {
        var scope = this;
        var timer = JSON.parse(localStorage.getItem("timer" + this.props.work.id));
        var timerId = window.setInterval(() => {
            scope.setState({ currentTime: ((new Date() - new Date(timer.startTime)) / 1000).toFixed(0) });
        }, 1000);
        timer.timerId = timerId;
        localStorage.setItem("timer" + this.props.work.id, JSON.stringify(timer));
    }
    



    handleCommentClose() {
        this.setState({ isCommentDialogOpen: false });
    }

    handleCommentSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/FlagAndComment', {
            method: 'POST',
            body: JSON.stringify({ WorkId: this.props.work.id, Comment: this.state.flagComment, Flag: this.state.newFlag }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                mainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onWorkUpdate) {
                        scope.props.onWorkUpdate(result)
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ isCommentDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleTopClick() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/SendToTop', {
            method: 'POST',
            body: JSON.stringify({ WorkId: this.props.work.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                mainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onWorkUpdate) {
                        scope.props.onWorkUpdate(result)
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ isCommentDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDownClick() {
    }

    contextTrigger = null;

    render() {
        return (
            <div onClick={this.handleCardClick}
                className={"clearfix card-wrapper priority-shadow-" + this.props.work.priorityId + (this.state.isOver ? 'over' : '') + (this.props.work.isSelected ? ' selected' : '') + (!this.props.work.isFlagged ? '' : ' flagged')}
            >
                <div className="not-pointers client-card">
                    <CardRow className={"clearfix priority-gradient-" + this.props.work.priorityId}>
                        <div className="small-card-number"><CopyToClipboard onCopy={() => { this.setState({ snackbarOpen: true, newNotify: 'Скопировано в буфер обмена' }); }} text={document.location.origin + '/board?work=' + encodeURIComponent(this.props.work.number)}><span>{this.props.work.number}</span></CopyToClipboard></div>
                    </CardRow>
                    <div onClick={(e) => { !e.ctrlKey && this.props.onCardOpen(this.props.work) }}>
                        <CardRow>
                            <div className="small-card-caption">{this.props.work.caption}</div>
                            <div className="client-sp-block">{this.props.work.approvedHour}</div>
                        </CardRow>

                        <CardRow>
                            <div className="project-block" style={{ background: this.props.work.projectColor }}>{this.props.work.projectName}</div>
                            <div className="work-card-avatar-block">{this.props.work.assigneeId && <UserAvatar userId={this.props.work.assigneeId} />}</div>
                        </CardRow>
                        {this.props.work.tester && <CardRow>
                            Тестирует <div className="work-card-avatar-block">{this.props.work.tester}</div>
                        </CardRow>}
                    </div>
                </div>


                <Dialog
                    onClose={this.handleCommentClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isCommentDialogOpen}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleCommentClose}>
                        {this.state.flagDialogTitle}
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography>
                            <TextField required
                                id="standard-required"
                                label="Комментарий"
                                fullWidth
                                margin="normal"
                                value={this.state.flagComment}
                                multiline
                                onChange={this.handleChange('flagComment')} 
                            />
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCommentSave} color="primary">
                            Сохранить
                        </Button>
                        <Button onClick={this.handleCommentClose} color="primary">
                            Отменить
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleSnackbarClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.state.newNotify}</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.handleSnackbarClose}
                            size="large">
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </div>
        );
    }
}
